import { useRef } from 'react';
import { Whisper, Button } from 'rsuite';
import { TableCell } from '@mui/material';
import { icons } from '@shared/static/icons';
import { MemberActionCellMenu } from '@widgets/teams/menu';

export function MemberActionMenu({ data }) {
  const ref = useRef();

  function close() {
    ref.current.close();
  }

  return (
    <Whisper
      placement="auto"
      controlId="control-id-with-dropdown"
      trigger="click"
      ref={ref}
      speaker={<MemberActionCellMenu data={data} close={close} />}
    >
      <Button appearance="secondary" className="rs-btn-icon">
        {icons.more}
      </Button>
    </Whisper>
  );
}

export default function MemberActionCell({ row }) {
  return (
    <TableCell className="table-cell-actions">
      <MemberActionMenu data={row} />
    </TableCell>
  );
}
